// when button-card click, add class _active to this and remove class _active from all other button-card
$('.button-card').click(function() {
    $(this).parents('.row').find('.button-card').removeClass('_active');
    $(this).addClass('_active');

    // add value to .coupon-input from this attribute data-coupon
    $('.coupon-input').val($(this).attr('data-coupon'));
});
